jQuery( document ).ready( function ( $ ) {

    //animation for images

    let cardsSliderItems = $('.small-cards-slider-list__item-title');
    let blockSmallCardsWithHoverSlider = $('.block-small-cards-with-hover-slider');

    let cardsSliderItemsList = document.querySelectorAll('.small-cards-slider-list__item');
    let cardsSliderItemsTitleList = document.querySelectorAll('.small-cards-slider-list__item-title');

    let maxHeight = 0;
    cardsSliderItemsList.forEach(element => {
        let elementHeight = element.clientHeight;
        if (elementHeight > maxHeight) {
            maxHeight = elementHeight;
        }
    });

    cardsSliderItemsTitleList.forEach((e) => {
        e.style.height = `${maxHeight}px`
    })


    if(window.innerWidth >= 1200) {
        $(cardsSliderItems).hover(function(){
            let activeItem = $(this).closest('.small-cards-slider-list__item');
            let indexData = $(activeItem).data('index');

            // animate(indexData, 'active')
        }, function(){
             let activeItem = $(this).closest('.small-cards-slider-list__item');
             let indexData = $(activeItem).data('index');

             //animate(indexData, 'inactive');
        });

    }

    function animate(indexData, status) {
        let activeImg = $('.small-cards-slider-list__item-image[data-index=' + indexData + ']')
        $(activeImg).addClass( 'active' );
        let img = $('img', activeImg);

        if (status === 'active' && !($('body').hasClass('without-animation'))) {
            let counterDelay = 0;
            $(img).each(function (){
                $(this).css('transition-delay', `${counterDelay}s`)
                counterDelay += 0.15
            });
        }

        if (status === 'inactive') {
            $(activeImg).removeClass( 'active' );
            $(img).each(function (){
                $(this).css('transition-delay', `0s`)
            });
        }
    }

    //animation for the bg and title
    function onEntryBlock(entry) {
        entry.forEach(change => {
            if (change.isIntersecting) {
                change.target.classList.add('bg-blue-animate');
                addAnimForTitle()
            }
        });
    }

    let optionsBlock = {
        root: null,
        rootMargin: '0px',
        threshold: .5
    };

    let observerBlock = new IntersectionObserver(onEntryBlock, optionsBlock);

    for (let elm of blockSmallCardsWithHoverSlider) {
        observerBlock.observe(elm);
    }

    function addAnimForTitle() {
        let smallCardsSliderList = $('.small-cards-slider-list.slick-active')
        $(smallCardsSliderList).addClass('element-show')
    }

    //slider

    let sliderSettings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: false,
        accessability: false,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    dots: false,
                    arrows: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    dots: false,
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true
                }
            }
        ]
    };

    function initSlider() {
        initCustonSliderNav($( '.small-cards-slider-list-block' ), $('.small-cards-slider .slider-nav-dots'), sliderSettings)
    }
    initSlider();

    if ($(body).attr('data-zoom') > 20 )  {
        $('.small-cards-slider-list-block').slick('slickSetOption', {
            'slidesToShow': 1,
            'slidesToScroll': 1,
        }, true);
    } else {
        $('.small-cards-slider-list-block').slick('slickSetOption', {
            'slidesToShow': 2,
            'slidesToScroll': 2,
        }, true);
    }

    $('.small-cards-slider-list-block').on('afterChange', function(){
        addAnimForTitle()
    });


    $(document).on('accessibilityPreEvent', function (e) {
        if (e.originalEvent.detail['counter'] > 20) {
            $('.small-cards-slider-list-block').slick('slickSetOption', {
                'slidesToShow': 1,
                'slidesToScroll': 1,
            }, true);
        } else {
            $('.small-cards-slider-list-block').slick('slickSetOption', {
                'slidesToShow': 2,
                'slidesToScroll': 2,
            }, true);
        }
    });
})
